import {
    getNormalisedUrl,
    getTrackingUrlFromElement,
    gtmPush,
    navigationClickTracking,
} from "./helpers";

function layoutTracking() {
    // 1. Navigation Click
    function navigationTracking() {
        const mainNav = document.querySelector(".main-navigation__main");
        if (!mainNav) return;

        const navItems = [
            {
                selector: ".main-navigation__control-link",
                type: "nav-links",
                handler: (e, el) => {
                    const btnTextRaw = el.textContent || "";
                    const btnText = btnTextRaw.replace(/\s+/g, " ").trim();
                    const isPressed =
                        el.getAttribute("aria-pressed") === "true";
                    const navState = isPressed ? "closed" : "open";

                    navigationClickTracking(btnText, null, 1, navState);
                },
            },
            {
                selector: "#main-nav-bookmarks",
                type: "nav-bookmark",
                handler: (e, el) => {
                    const btnText = el.innerText.trim();
                    navigationClickTracking(
                        btnText,
                        getTrackingUrlFromElement(el),
                        1,
                    );
                },
            },
            {
                selector: "#main-nav-close",
                type: "nav-search",
                handler: (e, el) => {
                    const btnText = el.outerText.trim();
                    navigationClickTracking(btnText, null, 1);
                },
            },
            {
                selector: "#main-nav-quiz",
                type: "nav-quiz",
                handler: (e, el) => {
                    navigationClickTracking(
                        "Senior Road User Quiz",
                        getTrackingUrlFromElement(el),
                        1,
                    );
                },
            },
        ];

        navItems.forEach((item) => {
            const elements = mainNav.querySelectorAll(item.selector);

            elements.forEach((el) => {
                if (el.dataset.navTracked) return;
                el.dataset.navTracked = "true";

                el.addEventListener("click", (e) => {
                    item.handler(e, el);
                });
            });
        });

        /*  SUB MENU LINK TRACKING */

        const subNavWrapper = document.querySelector(".main-navigation__aside");
        if (!subNavWrapper) return;

        // Use event delegation to catch all subnav link clicks
        // This works regardless of when the subnav is opened
        if (subNavWrapper.dataset.subNavTrackingSetup) return;
        subNavWrapper.dataset.subNavTrackingSetup = "true";

        subNavWrapper.addEventListener("click", (e) => {
            // Find the clicked link
            const link = e.target.closest(
                ".main-navigation__content-list li a",
            );
            if (!link) return;

            // Only track if the link is within an active menu
            const activeMenu = link.closest(".main-navigation__content.active");
            if (!activeMenu) return;

            const linkText = link.textContent.replace(/\s+/g, " ").trim();

            navigationClickTracking(
                linkText,
                getTrackingUrlFromElement(link),
                2,
            );
        });
    }

    // 2. Footer Nav
    function footerNavTracking() {
        const footerWrapper = document.querySelector(".footer__wrapper");
        if (!footerWrapper) return;

        footerWrapper.addEventListener("click", (e) => {
            // Find the closest relevant link
            const link = e.target.closest(
                ".footer__col-second-button_wrapper a, .footer__logo-link",
            );
            if (!link) return;

            // Get the URL from the <a> tag
            const url = link.getAttribute("href") || "";

            // Social links
            if (link.matches(".footer__col-second-button_wrapper a")) {
                gtmPush({
                    event: "navigation_click",
                    navigation_type: "footer_nav",
                    click_text: "Social",
                    click_url: getNormalisedUrl(url),
                    nav_level: 1,
                });
            }

            // Logo links
            if (link.matches(".footer__logo-link")) {
                gtmPush({
                    event: "navigation_click",
                    navigation_type: "footer_nav",
                    click_text: "logo",
                    click_url: getNormalisedUrl(url),
                    nav_level: 1,
                });
            }
        });
    }

    // 3. Breadcrumb click
    function breadcrumbTracking() {
        const breadcrumb = document.querySelector(".breadcrumb");

        if (!breadcrumb) {
            return;
        }

        const breadcrumbLinks =
            breadcrumb.querySelectorAll(".breadcrumb__link");

        breadcrumbLinks.forEach((link, index) => {
            // Prevent duplicate listeners
            if (link.dataset.breadcrumbTracked) return;
            link.dataset.breadcrumbTracked = "true";

            link.addEventListener("click", function (e) {
                // Stop event propagation to prevent duplicate tracking
                e.stopPropagation();

                const clickText = link.textContent?.trim() || "";
                const clickUrl = link.getAttribute("href") || "";
                const navLevel = index + 1; // Position in list (1-based)

                // Track if we have either text or URL
                if (clickText || clickUrl) {
                    gtmPush({
                        event: "navigation_click",
                        navigation_type: "breadcrumb",
                        click_text: clickText || "Breadcrumb",
                        click_url: getNormalisedUrl(clickUrl),
                        nav_level: navLevel,
                    });
                }
            });
        });
    }
    // 4. pageview
    // function pageviewTracking() {
    //     const pageTitle = document.title?.trim() || "";
    //     const pageUrl = window.location.href || "";

    //     gtmPush({
    //         event: "pageview",
    //         page_title: pageTitle,
    //         page_url: pageUrl,
    //     });
    // }

    function pagePreviewData() {
        const pageData = window.squizPageviewData || {};
        const { assetLineage = [], content_type } = pageData;

        // fixed groups 1–4 as per PDF
        const groups = {
            content_group: assetLineage[0] || "undefined",
            content_group2: assetLineage[1] || "undefined",
            content_group3: assetLineage[2] || "undefined",
            content_group4: assetLineage[3] || "undefined",
        };

        // page view counter
        function incrementPageViewCount() {
            const key = "page_view_count";
            const count = Number(sessionStorage.getItem(key)) || 0;
            const newCount = count + 1;
            sessionStorage.setItem(key, newCount);
            return newCount;
        }

        // pass to GTM
        gtmPush({
            ...groups,
            event: "content",
            content_type,
            incremental_page_view: incrementPageViewCount(),
        });
    }

    function bookmarkTracking() {
        // Use event delegation to catch all bookmark clicks, including dynamically added ones
        // This works even if buttons are added by React after page load
        if (document.body.dataset.bookmarkTrackingSetup) return;
        document.body.dataset.bookmarkTrackingSetup = "true";

        document.body.addEventListener("click", (e) => {
            // Check if the clicked element is a bookmark button
            const button = e.target.closest(".bookmark");
            if (!button) return;

            // Check if button is within a rec-card or article card container
            const recCard = button.closest(".rec-card, .rec-card-hero");
            const articleCard = button.closest(".cards-articles__item");

            // Only proceed if button is within a supported container
            if (!recCard && !articleCard) return;

            // Prevent duplicate tracking for the same click
            if (button.dataset.bookmarkClickTracked) return;
            button.dataset.bookmarkClickTracked = "true";

            // Reset flag after a short delay
            setTimeout(() => {
                delete button.dataset.bookmarkClickTracked;
            }, 1000);

            // Stop event propagation to prevent link click from also firing
            e.stopPropagation();

            // Capture state BEFORE click to determine what action was taken
            const wasActiveBefore = button.classList.contains("active");

            // Check state after click to determine interaction type
            // Use setTimeout to check state after toggle completes
            setTimeout(() => {
                // Check both active class and aria-pressed for reliability
                const isActiveNow = button.classList.contains("active");
                const isAriaPressedNow =
                    button.getAttribute("aria-pressed") === "true";

                // Determine interaction type based on state change
                // If it wasn't active before and is active now = ADDED
                // If it was active before and isn't active now = REMOVED
                const interactionType =
                    !wasActiveBefore && isActiveNow
                        ? "add"
                        : wasActiveBefore && !isActiveNow
                          ? "remove"
                          : // Fallback to aria-pressed if class check is unclear
                            isAriaPressedNow
                            ? "add"
                            : "remove";

                // Determine component_name and extract title based on card type
                let componentName = "";
                let componentElement = "";

                if (recCard) {
                    // For recommendation cards
                    componentName = "rec-card";
                    const titleEl =
                        recCard.querySelector(".rec-card__title") ||
                        recCard.querySelector(".rec-card-hero__title");
                    if (titleEl) {
                        const titleRaw = titleEl.textContent?.trim() || "";
                        componentElement = titleRaw.replace(/\s+/g, " ").trim();
                    }
                } else if (articleCard) {
                    // For article cards
                    componentName = "card_article";
                    const titleEl =
                        articleCard.querySelector(".article__title");
                    if (titleEl) {
                        const titleRaw = titleEl.textContent?.trim() || "";
                        componentElement = titleRaw.replace(/\s+/g, " ").trim();
                    }
                }

                // Fallback: Extract from aria-label if title not found
                // Format: "Bookmark for Alternatives to driving" -> "Alternatives to driving"
                if (!componentElement) {
                    const ariaLabel = button.getAttribute("aria-label") || "";
                    if (ariaLabel) {
                        // Remove "Bookmark " or "Bookmark for " prefix if present
                        const labelMatch = ariaLabel.match(
                            /Bookmark (?:for )?(.+)/i,
                        );
                        if (labelMatch && labelMatch[1]) {
                            componentElement = labelMatch[1]
                                .replace(/\s+/g, " ")
                                .trim();
                        } else {
                            // Use the full aria-label if it doesn't match the pattern
                            componentElement = ariaLabel
                                .replace(/\s+/g, " ")
                                .trim();
                        }
                    }
                }

                // content_id from button ID - prefix with "bookmark_"
                let contentId = "";
                const buttonId = button.getAttribute("id");
                if (buttonId) {
                    // Extract ID from formats like "bookmark_571543" or just use the full ID
                    const idValue =
                        buttonId.replace(/^bookmark_?/, "") || buttonId;
                    contentId = `bookmark_${idValue}`;
                }

                // Push to GTM
                gtmPush({
                    event: "bookmark_click",
                    interaction_type: interactionType,
                    component_name: componentName,
                    component_element: componentElement,
                    content_id: contentId || "",
                });
            }, 10);
        });
    }

    function initLayout() {
        navigationTracking();
        footerNavTracking();
        breadcrumbTracking();
        pagePreviewData();
        bookmarkTracking();
    }

    initLayout();
}

export default layoutTracking;
